import React from 'react';
import './App.css';
import { Layout } from 'antd';
import { RouteObject, useRoutes } from 'react-router-dom';
import {
  AuthLayout,
  ConfirmEmailPage,
  ForgotPasswordPage,
  LoginPage,
  RegistrationPage,
  ResetPasswordPage,
} from './features/auth';
import CommonLayout from './features/common/Layout';
import { HelpPage, HomeLayout, HomePage, PartnersPage, RulesPage } from './features/home';
import { GamesLayout, HotGamePage, KnbGamePage } from './features/games';
import { NoMatchPage } from './features/home/pages/NoMatch.page';
import {
  DepositBalanceUserPage,
  MessagesUserPage,
  RemoveBalanceUserPage,
  SettingsUserPage,
  StatisticUserPage,
} from './features/user';
import { ConsoleLayout, NewsPage, UsersPage } from './features/console';
import routesConfig from './config/routes';
import 'dayjs/locale/ru';
import dayjs from 'dayjs';
import { ChatPage } from './features/games/pages/Chat.page';

dayjs.locale('ru');

function App() {
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <CommonLayout />,
      children: [
        {
          // index: true,
          element: <HomeLayout />,
          children: [
            { index: true, path: routesConfig.home, element: <HomePage /> },
            { path: routesConfig.partners, element: <PartnersPage /> },
            { path: routesConfig.rules, element: <RulesPage /> },
            { path: routesConfig.help, element: <HelpPage /> },
          ],
        },
        {
          path: '/auth',
          element: <AuthLayout />,
          children: [
            { index: true, path: routesConfig.login, element: <LoginPage /> },
            { path: routesConfig.registration, element: <RegistrationPage /> },
            { path: routesConfig.forgotPassword, element: <ForgotPasswordPage /> },
            {
              path: routesConfig.resetPassword,
              element: <ResetPasswordPage />,
            },
            {
              path: routesConfig.confirmEmail,
              element: <ConfirmEmailPage />,
            },
          ],
        },
        {
          element: <GamesLayout />,
          children: [
            { index: true, path: routesConfig.gameKnb, element: <KnbGamePage /> },
            { path: routesConfig.gameHot, element: <HotGamePage /> },
            { path: routesConfig.gameChat, element: <ChatPage /> },
            { path: routesConfig.userDepositBalance, element: <DepositBalanceUserPage /> },
            { path: routesConfig.userRemoveBalance, element: <RemoveBalanceUserPage /> },
            { path: routesConfig.userSettings, element: <SettingsUserPage /> },
            { path: routesConfig.userStatistic, element: <StatisticUserPage /> },
            { path: routesConfig.userMessages, element: <MessagesUserPage /> },
          ],
        },
        {
          element: <ConsoleLayout />,
          children: [
            { index: true, path: routesConfig.consoleUsers, element: <UsersPage /> },
            { path: routesConfig.consoleNews, element: <NewsPage /> },
          ],
        },
      ],
    },
    { path: '*', element: <NoMatchPage /> },
  ];

  const element = useRoutes(routes);

  return <Layout>{element}</Layout>;
}

export default App;
